import { useMutation } from "@tanstack/react-query";
import axios from "../api/axios";
import { endpoints } from "../api/endpoint";

export const useCalculateEmi = (version = "v1") => {
  let url = endpoints.loanEmiCalculation;
  if (version === "v2") {
    url = endpoints.loanEmiCalculationForAllFinanciers;
  }

  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await axios.post(url, payload, {
        headers: {
          authorization: `Bearer ${process.env.REACT_APP_BAAS_TOKEN}`,
          "content-type": "application/json",
        },
      });

      return data;
    },
  });
};
